import { setSessionStorage } from "./apiUtils";
import { SendData } from "./SendData";

const getNewUuid = (function () {
    // Для каждого uuidKey храним:
    // - promise: сам Promise
    // - resolve/reject: его резолверы
    const running = new Map();        // uuidKey → { promise, resolve, reject }
    const timers = new Map();        // uuidKey → timeoutId

    // Функция, которая реально делает запрос и рeзолвит/рeджектит promise
    function doRequest(uuidKey) {
        timers.delete(uuidKey);
        const { resolve, reject } = running.get(uuidKey);

        new SendData({
            data: { uuidKey },
            url: '/api/getNewUuid',
            uuidKey: uuidKey,
            type: 'API'
        })
            .then(response => {
                setSessionStorage(
                    ['uuid', response.answer.uuidKey],
                    response.answer.uuid
                );
                resolve(response.answer);
            })
            .catch(err => reject(err))
            .finally(() => {
                running.delete(uuidKey);
            });
    }

    return function (uuidKey) {
        // Если уже идёт отсчёт — просто сбросим таймер и вернём тот же promise
        if (running.has(uuidKey)) {
            clearTimeout(timers.get(uuidKey));
            timers.set(uuidKey, setTimeout(() => doRequest(uuidKey), 100));
            return running.get(uuidKey).promise;
        }

        // Иначе — создаём новый промис и ставим таймер
        let resolveFn, rejectFn;
        const promise = new Promise((res, rej) => {
            resolveFn = res;
            rejectFn = rej;
        });

        running.set(uuidKey, { promise, resolve: resolveFn, reject: rejectFn });
        timers.set(uuidKey, setTimeout(() => doRequest(uuidKey), 100));

        return promise;
    };
})();

export { getNewUuid };


export class TabIdManager {
    constructor() {
        this.STORAGE_KEY = 'open_tabs';
        this.SESSION_KEY = 'tab_hash';
        this.tabHash = this.initializeTabHash();
        this.updateLocalStorage();
        this.setupUnloadListener();
    }

    generateHash() {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID();
        } else {
            return this.fallbackUUID();
        }
    }

    fallbackUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    initializeTabHash() {
        let candidate = sessionStorage.getItem(this.SESSION_KEY);

        if (!candidate) {
            candidate = this.generateHash();
            sessionStorage.setItem(this.SESSION_KEY, candidate);
        }

        let storedTabs = [];
        try {
            const raw = localStorage.getItem(this.STORAGE_KEY);
            storedTabs = raw ? JSON.parse(raw) : [];
        } catch (_) { }

        if (storedTabs.includes(candidate)) {
            candidate = this.generateHash();
            sessionStorage.setItem(this.SESSION_KEY, candidate);
        }

        return candidate;
    }

    updateLocalStorage() {
        let tabs = [];
        try {
            const raw = localStorage.getItem(this.STORAGE_KEY);
            tabs = raw ? JSON.parse(raw) : [];
        } catch (_) { }

        if (!tabs.includes(this.tabHash)) {
            tabs.push(this.tabHash);
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(tabs));
        }
    }

    getTabHash() {
        return this.tabHash;
    }

    setupUnloadListener() {
        window.addEventListener('beforeunload', () => {
            try {
                const raw = localStorage.getItem(this.STORAGE_KEY);
                if (!raw) return;

                const tabs = JSON.parse(raw).filter(h => h !== this.tabHash);
                localStorage.setItem(this.STORAGE_KEY, JSON.stringify(tabs));
            } catch (_) { }
        });
    }
}

export async function getTabHash() {
    const key = window.tabIdManager.getTabHash();
    if (sessionStorage.getItem(['uuid', key])) {
        return key;
    }
    return key;
}

export async function getTabHashAndUuid() {
    const key = window.tabIdManager.getTabHash();
    if (sessionStorage.getItem(['uuid', key])) {
        return key;
    }
    await window.getNewUuid(key);
    return key;
}

export function randomUUID() {
    // Генерация UUID v4
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}